import { render, staticRenderFns } from "./returnAdd.vue?vue&type=template&id=ba8559fc"
import script from "./returnAdd.vue?vue&type=script&lang=js"
export * from "./returnAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports